import React, { useState, useRef, useEffect } from 'react';
import LogList from '../components/LogList';
import './DroneScreen.css';
import FilterModal from '../components/FilterModal';
import { SettingsType, UserType } from '../interfaces/SettingsType';
import StatistikWidget, { StatsWidgetRef } from '../components/StatsWidget';
import { FilterType } from '../interfaces/FilterType';
import ExportCSVButton from '../components/ExportCSVButton';

interface DroneScreenProps {
  settings: SettingsType;
  droneType: string | number;
  pilots: UserType[];
}

function calculateRowsPerPage(): number {
  const rowHeight = 60;   // angenommene Höhe pro Tabellenzeile
  const overhead = 400;   // z.B. Platz für Header, Footer, Paginierung etc.
  const freeHeight = window.innerHeight - overhead;

  // Mindestens 1, damit bei sehr kleinem Bildschirm kein 0 herauskommt
  return Math.max(Math.floor(freeHeight / rowHeight), 1);
}

const DroneScreen: React.FC<DroneScreenProps> = ({
  settings,
  droneType,
  pilots,
}) => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState<boolean>(false);
  const [activeFilters, setActiveFilters] = useState<FilterType[]>([
    { field: 'droneType', operator: '==', value: droneType },
  ]);
  const [itemsPerPageState, setItemsPerPageState] = useState<number>(
    calculateRowsPerPage()
  );
  const statsWidgetRef = useRef<StatsWidgetRef>(null);

  useEffect(() => {
    setItemsPerPageState(calculateRowsPerPage());
  }, []);
  

  function cycleItemsPerPage() {
    const options = [5, 10, 20, 50];
    const current = itemsPerPageState;
    const index = options.indexOf(current);
    if (index === -1) {
      setItemsPerPageState(options[0]);
    } else {
      const nextIndex = (index + 1) % options.length;
      setItemsPerPageState(options[nextIndex]);
    }
  }

  return (
    <div className="drone-container">
      <div className="drone-header">
        <h1 className="drone-title">
          Flugbuch {droneType === 'Matrice350RTK' ? 'DJI-M350' : 'DJI Mavic 2'}
        </h1>
        <div className="button-group">
          <button
            className="filter-button"
            onClick={() => setIsFilterModalOpen(true)}
          >
            Filter
          </button>
          <button
            className="update-button"
            onClick={() => statsWidgetRef.current?.refreshData()}
          >
            Aktualisieren
          </button>
          <button 
            className='update-button'
            onClick={cycleItemsPerPage}>
            {itemsPerPageState} pro Seite
          </button>
        </div>
      </div>

      <div className="stats-section-drone">
        <StatistikWidget
          ref={statsWidgetRef}
          droneType={droneType}
          isVisible={true}
        />
      </div>

      <LogList
        settings={settings}
        pilots={pilots}
        itemsPerPage={itemsPerPageState}
        isAdmin={settings.isAdmin}
        filters={activeFilters}
      />

      {isFilterModalOpen && (
        <FilterModal
          onClose={() => setIsFilterModalOpen(false)}
          onApply={(filters: FilterType[]) => {
            setActiveFilters([
              ...filters,
              { field: 'droneType', operator: '==', value: droneType },
            ]);
          }}
          settings={settings}
        />
      )}
    </div>
  );
};

export default DroneScreen;
